module.exports = "https://cdn-shared.mathletics.com/teacher-modules/curriculum-manager/15assets/fonts/fee66e712a8a08eef5805a46892932ad.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0
// module id = 671
// module chunks = 4